import { EMPTY_PLACEHOLDER } from '@patsnap/synapse_common_config'
import { IBaseDictItem, IDrugDetail } from '@patsnap/synapse_common_interface'
import { getDicItemName, openPageWithoutPending } from '@patsnap/synapse_common_utils'
import { E_UPGRADE_TYPE } from '@pharmsnap/pharmsnap-web/types/enum'
import { useAuthStore, useLocale } from '@pharmsnap/shared/src/composition'
import { sharedCtx } from '@pharmsnap/shared/src/context'
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { BMosaic, GLimited } from '../..'

export const BDrugModification = defineComponent({
  name: 'BDrugModification',
  props: {
    data: {
      type: Object as PropType<IDrugDetail>,
      required: true,
    },
    limit: {
      type: Number,
      default: 3,
    },
    mode: {
      type: String as PropType<'expand' | 'popover' | 'link'>,
      default: 'expand',
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { locale } = useLocale()
    const modificationItems = computed(() => props.data.modification_id_view || [])
    const hasModification = computed(() => modificationItems.value.length > 0)

    const {
      getters: { isTrialOrProfessionalUser },
      actions: { changeUpgrade },
    } = useAuthStore()

    const handleViewDetail = () => {
      if (isTrialOrProfessionalUser.value) {
        openPageWithoutPending(() => sharedCtx.router.generatorDrugModificationPath(props.data.drug_id))
        return
      }

      changeUpgrade({ show: true, type: E_UPGRADE_TYPE.USE_PAID_FEATURE_MODIFICATION, trigger_point: 'DRUG_MODIFICATION_VIEW_DETAIL' })
    }

    return {
      modificationItems,
      hasModification,
      locale,
      handleViewDetail,
    }
  },
  methods: {
    renderViewDetail() {
      return (
        <div
          class="inline-flex text-blue-hover cursor-pointer rounded border border-blue-hover px-1 leading-5 text-xs hover:bg-blue-light"
          onClick={this.handleViewDetail}
        >
          {`${this.$tc('common.viewDetail')} >>`}
        </div>
      )
    },
    renderModification() {
      return (
        <GLimited
          items={this.modificationItems}
          limit={this.limit}
          mode={this.mode}
          popoverStyle={this.mode === 'popover' ? 'width: 224px' : ''}
          gap={{ x: 0, y: 4, trigger: 4 }}
          inline={this.inline}
          popoverInline={this.inline}
          scopedSlots={{
            default: ({ item, index }: { item: IBaseDictItem; index: number }) => (
              <div style="line-height: 24px; font-size: 14px;" class="break-words whitespace-normal">
                {getDicItemName(item, this.locale)}
                {index !== this.modificationItems.length - 1 ? ';' : ''}
              </div>
            ),
          }}
        />
      )
    },
  },
  render() {
    return (
      <div class="pl-1">
        <BMosaic trigger_point="DRUG_MODIFICATION">{this.hasModification ? this.renderModification() : EMPTY_PLACEHOLDER}</BMosaic>
        {this.hasModification && <div class="mt-2">{this.renderViewDetail()}</div>}
      </div>
    )
  },
})
